import { bool, func, number, shape, string } from "prop-types"
import { capitalize } from "utils/helpers"
import { NumberSpinner } from "components/ui"
import { Box, StackView, Text } from "@planningcenter/tapestry-react"
import { colors } from "components/shared/admin_colors"
import Icon from "components/planning_center_icon"

const Selection = ({ selection, onChange }) => {
  const { id, name, availableCount, count, waitlist } = selection

  const handleChange = value => {
    const newCount = parseInt(value)
    onChange({
      id,
      count: newCount
    })
  }

  const tooltipText =
    "When you submit this registration, the capacity will be increased automatically."

  return (
    <StackView axis="horizontal" alignment="center" distribution="space-between" gap={2}>
      <Box css={{ flexShrink: 1 }}>
        <label htmlFor={`${id}_label`} className="mb-0">
          <Text size={3} color={colors.neutral_700} marginBottom="2px">
            {capitalize(name)}
          </Text>
        </label>

        {!waitlist && availableCount !== null && (
          <StackView axis="horizontal" alignment="flex-start" spacing={1}>
            <Text size={4} color={colors.neutral_600} marginBottom="4px">
              {count >= availableCount ? `Full` : `${availableCount - count} remaining`}
            </Text>
            {count > 0 && count > availableCount && (
              <Box data-tooltip={tooltipText}>
                <Icon
                  symbol="general#exclamation-triangle"
                  style={{ color: colors.warning }}
                  aria-label={tooltipText}
                />
              </Box>
            )}
          </StackView>
        )}
      </Box>

      <NumberSpinner
        name={`${id}_label`}
        showInput={false}
        initialValue={count}
        onChange={handleChange}
      />
    </StackView>
  )
}

Selection.propTypes = {
  selection: shape({
    id: number.isRequired,
    name: string.isRequired,
    availableCount: number,
    count: number,
    waitlist: bool
  }),
  onChange: func.isRequired
}

export default Selection
